import { useEffect } from 'react';
import { retryFeedbackOutbox } from '../lib/appFeedback';
import { FEEDBACK_RETRY_READY_EVENT } from '../lib/feedbackRetryQueue';

/** Quietly reconciles feedback work that outlived a lost connection or tab. */
export default function FeedbackOutboxSync({ uid }: { uid: string }) {
  useEffect(() => {
    const retry = () => { void retryFeedbackOutbox(uid); };
    const retryWhenVisible = () => {
      if (document.visibilityState === 'visible') retry();
    };

    retry();
    window.addEventListener('online', retry);
    window.addEventListener(FEEDBACK_RETRY_READY_EVENT, retry);
    document.addEventListener('visibilitychange', retryWhenVisible);
    const interval = window.setInterval(retry, 15 * 60 * 1000);
    return () => {
      window.removeEventListener('online', retry);
      window.removeEventListener(FEEDBACK_RETRY_READY_EVENT, retry);
      document.removeEventListener('visibilitychange', retryWhenVisible);
      window.clearInterval(interval);
    };
  }, [uid]);

  return null;
}
